import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import usePortfolioBalance from '../../hooks/usePortfolioBalance';
import { formatAdminWithdrawalDetails } from '../../utils/balanceUtils';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WithdrawalList() {
    const { coinRates } = usePortfolioBalance();
    const [withdrawals, setwithdrawals] = useState(null);
    const { isLoading: isLoadingwithdrawals, refetch: getwithdrawals } = useQuery(
        "list-withdrawals",
        async () => {
          return await apiClient.get("/api/list-withdrawals");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setwithdrawals(res.data.withdrawals);
                window.dispatchEvent(new Event('processed'));
            }
          },
        }
      );
    
      useEffect(() => {
        getwithdrawals();
      }, []);

      const [open2, setOpen2] = React.useState(false);
      const [withdrawalId, setwithdrawalId] = useState('');
      const [withdrawalStatus, setwithdrawalStatus] = useState('');
      const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);

      const handleClose2 = () => setOpen2(false);

      const { isLoading: isUpdating, mutate: updatewithdrawal } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-withdrawal`, {
            withdrawal_id: withdrawalId,
            withdrawal_status: withdrawalStatus,
          });
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                window.dispatchEvent(new Event('newMessage'));
                getwithdrawals();
                handleClose2();
                window.dispatchEvent(new Event('processed'));
              }
          },
          onError: (err) => {
            const errorMessage = err.response?.data?.message || err.message || 'Update failed';
            localStorage.setItem('notification', JSON.stringify({message : errorMessage, type: 'error' }));
            window.dispatchEvent(new Event('newMessage'));
            window.dispatchEvent(new Event('processed'));
          },
        }
      );

  const getDate = (date) => new Date(date).toLocaleString();
  const selectedDetails = selectedWithdrawal
    ? formatAdminWithdrawalDetails(selectedWithdrawal, coinRates)
    : null;

  return (
    <div style={{marginTop: '75px'}}>
    <Container maxWidth="xl">
        <Typography mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        {isLoadingwithdrawals ? 'Loading...' : 'List of withdrawals'}
      </Typography>
    <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
      {withdrawals !== null && (
      <Table sx={{ minWidth: 1100 }} size="small">
      <TableHead>
        <TableRow>
        <TableCell>User</TableCell>
        <TableCell>Email</TableCell>
        <TableCell align="right">USD requested</TableCell>
        <TableCell align="right">Coin deducted</TableCell>
        <TableCell align="right">Rate @ booking</TableCell>
        <TableCell align="right">Live USD</TableCell>
        <TableCell>Coin</TableCell>
        <TableCell>Address</TableCell>
        <TableCell>Dest. tag</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Date</TableCell>
        <TableCell align="right">Edit</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {withdrawals.map((withdrawal) => {
          const d = formatAdminWithdrawalDetails(withdrawal, coinRates);
          return (
          <TableRow key={withdrawal.id}>
            <TableCell>{withdrawal.user?.name}</TableCell>
            <TableCell sx={{ maxWidth: 160, wordBreak: 'break-all', fontSize: 12 }}>
              {withdrawal.user?.email}
            </TableCell>
            <TableCell align="right" sx={{ fontWeight: 600 }}>{d.usd}</TableCell>
            <TableCell align="right">{d.coinUnits}</TableCell>
            <TableCell align="right" sx={{ fontSize: 12 }}>{d.rate}</TableCell>
            <TableCell align="right">{d.liveUsd}</TableCell>
            <TableCell>{withdrawal.coin_name || withdrawal.source}</TableCell>
            <TableCell sx={{ maxWidth: 140, wordBreak: 'break-all', fontSize: 11 }}>
              {withdrawal.address}
            </TableCell>
            <TableCell sx={{ fontSize: 12 }}>
              {withdrawal.destination_tag || '—'}
            </TableCell>
            <TableCell>{withdrawal.status}</TableCell>
            <TableCell sx={{ fontSize: 12, whiteSpace: 'nowrap' }}>{getDate(withdrawal.created_at)}</TableCell>
            <TableCell align="right">
              <Button
                size="small"
                onClick={() => {
                  setOpen2(true);
                  setwithdrawalId(withdrawal.id);
                  setSelectedWithdrawal(withdrawal);
                  setwithdrawalStatus('');
                }}
                startIcon={<EditIcon />}
              >
                Edit
              </Button>
            </TableCell>
          </TableRow>
          );
        })}
      </TableBody>
    </Table>
      )}
    </TableContainer>
    </Container>

    <Dialog open={open2} TransitionComponent={Transition} keepMounted onClose={handleClose2}>
        <DialogTitle sx={{textAlign: 'center'}}>Update withdrawal status</DialogTitle>
        <DialogContent>
          {selectedDetails && selectedWithdrawal && (
            <Box sx={{ mb: 2, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
              <Typography variant="body2">USD: {selectedDetails.usd}</Typography>
              <Typography variant="body2">Coin: {selectedDetails.coinUnits}</Typography>
              <Typography variant="body2">Rate: {selectedDetails.rate}</Typography>
              <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                Address: {selectedWithdrawal.address}
              </Typography>
              {(selectedWithdrawal.coin_name === 'XRP' || selectedWithdrawal.source === 'XRP') && (
                <Typography variant="caption" display="block">
                  Destination tag: {selectedWithdrawal.destination_tag || '—'}
                </Typography>
              )}
            </Box>
          )}
          <FormControl fullWidth sx={{ m: 1 }}>
            <InputLabel htmlFor="status">Status</InputLabel>
                <Select
                    onChange={(e) => setwithdrawalStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label="Status"
                    value={withdrawalStatus}
                    >
                    <MenuItem value="">Select status</MenuItem>
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value="approved">approved</MenuItem>
                    <MenuItem value="declined">declined</MenuItem>
                </Select>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose2}>Cancel</Button>
            <Button onClick={() => updatewithdrawal()} disabled={!withdrawalStatus} variant="contained">
              {isUpdating ? 'Updating...' : 'Update status'}
            </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
